import { render, staticRenderFns } from "./videoplay.vue?vue&type=template&id=5f735312&scoped=true&"
import script from "./videoplay.vue?vue&type=script&lang=js&"
export * from "./videoplay.vue?vue&type=script&lang=js&"
import style0 from "./videoplay.vue?vue&type=style&index=0&id=5f735312&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f735312",
  null
  
)

export default component.exports